module.exports = __webpack_public_path__ + "img/symbol_11.54663ad2.png";